import { UrlConfig } from '@shared/configs/URL'

import { CompaniesFactoryAPI } from './api'

export const CompaniesClient = CompaniesFactoryAPI({
  apiUrl: UrlConfig.companiesApiUrl,
})
